<div class="home-shell">
  <img src="assets/images/logo-White.png" style="height: 400px;">
  <div class="centreText">
  <label class="HomeText">Racketlon is Table Tennis, Badminton, Squash & Tennis in that order.<br>
    Each sport is played up to 21 points, most points at the end wins.<br>
    For the love of racket sports!</label>
  </div>
</div>
<div class="HomeMiddleText">
  <label >The origins of racketlon can be traced back to Scandinavia in the mid Eighties, where four people
representing each of the four racket federations got together in Finland to form a game they called
mailapelit – i.e. “racket games”. The first Finnish Championships were held in Helsinki in 1986 and
the sport rapidly grew and slowly changed to the Racketlon format.</label><br>
  <label>Racketlon NZ had it’s first tournament on October 26 2013 in North Harbour.</label>
</div>
<div class="HomeBottomText">
  <label style="color: darkcyan; font-weight: 500;">Our sponsor</label><br>
  <label style="width: 60%">Salming have been the biggest supporter for our Racketlon tournaments -<br>
please consider our sponsor when ordering gear</label><br>
  <img src="assets/images/Salming-Logo-No-Nonsense.jpg" style="height: 100px;">
</div>



